module.exports = __webpack_public_path__ + "img/IMG_9000.a7f2f455.jpg";